<template>
    <div class="pdf-image-container no-select"
         :style="data.styleContainer"
    >
       <div class="page"
            :style="data.stylePage"
        >
            <img class="page-img"
                 :src="data.pageImgSrc"
            />
        </div>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed}  from "vue"
    import {usePaging} from "@/modules/reader/book/paging";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {appendAccessToken} from  "@/modules/utils/pathUtils";
    import {isTouchDevice, isIOS} from "@/modules/utils/deviceUtils";
    import cssvar from '@/scss/_variables.scss';

    const headerHeight = parseInt(cssvar.headerHeight)
    const footerHeight = parseInt(cssvar.footerHeight)

    export default {
        props: {
          side:String
        },
        setup(props, context) {

            const { pageState, setCurrentPage} = usePaging();
            const { pageResizeState, setFittedBrowserHeight, setBaseWidth, setBaseHeight} =  usePageResize();
            const { bookInfoState} = useBookInfo();

            const data = reactive({
                styleContainer:computed(()=>{
                    return {
                        maxWidth:`${pageResizeState.fittedBrowserWidth}px`,
                       // top: (props.side === "left" && pageState.isRightPageAvailable) ? `${(headerHeight - headerHeight / pageResizeState.zoomLevelLeft)}px` : 0
                    }
                }),
                stylePage: computed(()=>{

                    if (props.side === "left") {
                        return {
                            right:"0"
                        }
                    } else {
                        return {
                            left: '0'
                        }
                    }
                }),
                pageImgSrc: computed(()=>{
                    if (props.side === "left") {
                        //return appendAccessToken(`${bookInfoState.ebookDownloadPath}/page-image/page-${pageState.currentPage[0]}.jpg`);
                        return `${bookInfoState.ebookDownloadPath}/page-image/page-${pageState.currentPage[0]}.jpg`;
                    } else {
                        //return appendAccessToken(`${bookInfoState.ebookDownloadPath}/page-image/page-${pageState.currentPage[0] + 1}.jpg`);
                        return `${bookInfoState.ebookDownloadPath}/page-image/page-${pageState.currentPage[0] + 1}.jpg`;
                    }
                }),
                stylePageImg: computed(()=>{
                    if (pageState.pageMode === "double") {
                        if (props.side === "left") {
                            return {
                                right: 0
                            }
                        } else {
                            return {
                                left: 0
                            }
                        }
                    }
                })
            });

            const pageImageOnResized = (e) => {
                updateInitialFittedHeight();
            }

            /**
             * Adjust the image size so that it can fit in the reader view area
             */
            const updateInitialFittedHeight = () => {
                //multiply window height by window.visualViewport.scale to fix safari scale problem on orientation change
                let scale = (isIOS() ) ? Math.max(1, window.visualViewport.scale) : 1;
                setFittedBrowserHeight(window.innerHeight  * scale - headerHeight - footerHeight , window.innerWidth * scale);
            }

            onMounted(() => {
                if (isTouchDevice()) {
                    window.addEventListener("orientationchange",()=>{
                        setTimeout(pageImageOnResized, 200)
                    });
                } else {
                    window.addEventListener("resize", pageImageOnResized);
                }

                pageImageOnResized();
            })

            return {
                data,
                pageState,
                setCurrentPage,
                pageResizeState,
                setBaseWidth,
                setBaseHeight,
                setFittedBrowserHeight,
                bookInfoState,
                pageImageOnResized
            }
        }
    }
</script>

<style scoped lang="scss">

    .pdf-image-container {
       position:absolute;
        width:100%;
        height:auto;
    }

    .page {
         position:absolute;
         height:100%;
         width:100%;

        .page-img  {
            width:100%;
            //critical: not set height 100% will make it work on ipad!
           position:absolute;
            top:0;
        }
    }

</style>